import type { LayerKey } from '@festina-life/api'
import { FormikSelect } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { validateKey } from './helpers'
import { useNonConfiguredModeledEnums } from './useNonConfiguredModeledEnums'

type Props = {
  layer: LayerKey
  block: string
}

export const NonConfiguredEnumsCombobox = ({ layer, block }: Props) => {
  const translate = useTranslate()
  const nonConfiguredEnums = useNonConfiguredModeledEnums(layer, block)

  return (
    <FormikSelect
      name={validateKey('name')}
      label={translate('enumDraftForm.enumName.label')}
      description={translate('enumDraftForm.enumName.description')}
      options={nonConfiguredEnums}
      isValueCreator
      valueFromString={(value) => value}
    />
  )
}
